export default __webpack_public_path__ + "static/media/FakeJapanese05-Suport.22e865e8.svg";